<template>
  <b-container>
    <user-emails-by-ids />
    <hr>
    <email-bulk-settings />
  </b-container>
</template>

<script>
import UserEmailsByIds from '@/components/users/user-emails/UserEmailsByIds';
import EmailBulkSettings from '@/components/users/user-emails/EmailBulkSettings';
export default {
  name: 'UserEmails',
  components: {
    UserEmailsByIds,
    EmailBulkSettings,
  },
};
</script>

<style scoped></style>
